// extracted by mini-css-extract-plugin
export default {"section":"MedicalDebtQuizPage_section__z6Jhy","holder":"MedicalDebtQuizPage_holder__J0inO"};